/* eslint-disable no-param-reassign */
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    // rect.left >= 0 &&
    rect.bottom <= (window.innerHeight + 300 || document.documentElement.clientHeight + 300) // &&
    // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}


function lazyload() {
  [].forEach.call(document.querySelectorAll('img[data-source]'), function (img) {
    if (isElementInViewport(img)) {
      img.setAttribute('src', img.getAttribute('data-source'));
      img.onload = function () {
        img.removeAttribute('data-source');
      };
    }
  });
}


$(window).on('DOMContentLoaded load resize scroll', lazyload);
$(document).on('ajaxStop', lazyload);
